import { EventStatusFilterEnum } from "./event-status-filter.enum";

export class MyEventsFilters {
    page: number;

    ownedEventsStatus: EventStatusFilterEnum[] = [];
    joinedEventsStatus: EventStatusFilterEnum[] = [];
}
